import { useEffect, useState } from "react";
import { parseImage } from "../../utils/parseImage";
import { ImageComponentProps } from "../../entities/ImageComponent";
import { ImageComponentStyled } from "./ImageComponentStyled";
import NoImage from "../Icons/NoImage";

const ImageComponent: React.FC<ImageComponentProps> = ({ url, name }) => {
  const [isImageValid, setIsImageValid] = useState<boolean>(true);
  const parsedImage = parseImage(url);

  useEffect(() => {
    const imgElement = new Image();

    const handleLoad = (): void => {
      setIsImageValid(true);
    };

    const handleError = (): void => {
      setIsImageValid(false);
    };

    imgElement.addEventListener("load", handleLoad);
    imgElement.addEventListener("error", handleError);

    imgElement.src = parsedImage;

    return () => {
      imgElement.removeEventListener("load", handleLoad);
      imgElement.removeEventListener("error", handleError);
    };
  }, [parsedImage]);

  return (
    <ImageComponentStyled>
      {isImageValid ? (
        <img src={parsedImage} alt={name} className="product-image" />
      ) : (
        <div className="no-image">
          <NoImage />
        </div>
      )}
    </ImageComponentStyled>
  );
};

export default ImageComponent;
